import { UseQueryResult, queryOptions, useQuery } from '@tanstack/react-query';
import { IRoundBoardResponse, IRoundRightsResponse } from '../../data-models/round-governance.data-model';
import { getRoundBoard, getRoundRights } from '../queries/MaggieRoundGovernanceQueries';

/** Query key factory for type safety and consistency */
export const roundGovernanceKeys = {
  all: ['round-governance'] as const,
  board: (roundId?: number | null) => [...roundGovernanceKeys.all, 'board', roundId] as const,
  rights: (roundId?: number | null) => [...roundGovernanceKeys.all, 'rights', roundId] as const,
};

export const roundBoardQueryOptions = (roundId?: number | null) =>
  queryOptions({
    queryKey: roundGovernanceKeys.board(roundId),
    queryFn: () => getRoundBoard(roundId!),
    enabled: Boolean(roundId),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

export const roundRightsQueryOptions = (roundId?: number | null) =>
  queryOptions({
    queryKey: roundGovernanceKeys.rights(roundId),
    queryFn: () => getRoundRights(roundId!),
    enabled: Boolean(roundId),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

export function useRoundBoard(roundId?: number | null): UseQueryResult<IRoundBoardResponse, Error> {
  return useQuery(roundBoardQueryOptions(roundId));
}

export function useRoundRights(roundId?: number | null): UseQueryResult<IRoundRightsResponse, Error> {
  return useQuery(roundRightsQueryOptions(roundId));
}
